import CrehanaLogo from '@crehana/icons/logos/Crehana';
import CrehanaPremium from '@crehana/icons/logos/CrehanaPremium';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Container, colors } from '@crehana/ui';
import { useMe } from '@crehana/web';

const { white } = colors;

interface CustomNavbarProps {
  isRenovationFlow?: boolean;
  isClient?: boolean;
  isBgTransparent?: boolean;
}

const CustomNavbar: React.FC<React.PropsWithChildren<CustomNavbarProps>> = ({
  isRenovationFlow,
  isClient,
  isBgTransparent,
}) => {
  const { me } = useMe();

  const homeUrl = me?.organization?.slug
    ? `/org/${me.organization.slug}/`
    : '/';

  const renderLoginLogo = () => {
    if (isRenovationFlow && !isClient) {
      return null;
    }

    return isRenovationFlow ? (
      <CrehanaPremium size={36} color={white} />
    ) : (
      <CrehanaLogo size={24} color={white} />
    );
  };

  return (
    <div
      className={`${
        isBgTransparent ? 'bg-transparent' : 'bg-base-main'
      } w-full`}
    >
      <Container>
        <p className="inline-block">
          <a
            href={homeUrl}
            className="flex items-center justify-center py-32 sm:justify-start"
          >
            {renderLoginLogo()}
          </a>
        </p>
      </Container>
    </div>
  );
};

export default CustomNavbar;
